<template>
  <v-row dense>
    <v-col cols="12" xl="12">
      <v-card elevation="0" class="all-trade-tab rounded-0 mb-0 px-3 py-5" :color="$vuetify.theme.dark ? '#162334' : '#e8f1f8'">
        <v-tabs
          :background-color="
            $vuetify.theme.dark ? 'blue-darken-2 ' : 'white-lighten-5'
          "
          class="pa-0"
        >
          <v-tab class="ml-0"> Running Trade</v-tab>
          <v-tab> Closed Trade </v-tab>
          <v-tab> My Deposit </v-tab>
          <v-tab> My Withdraw </v-tab>
          <v-tab-item>
            <v-card flat class="mb-0">
              <RunningTradeTab></RunningTradeTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <ClosedTradeTab></ClosedTradeTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <MyDepositTab></MyDepositTab>
            </v-card>
          </v-tab-item>
          <v-tab-item>
            <v-card flat>
              <MyWithdrawTab></MyWithdrawTab>
            </v-card>
          </v-tab-item>
        </v-tabs>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import ClosedTradeTab from "@/components/TradeMaster/TradingMarketTab/ClosedTradeTab.vue";
import MyDepositTab from "@/components/TradeMaster/TradingMarketTab/MyDepositTab.vue";
import MyWithdrawTab from "@/components/TradeMaster/TradingMarketTab/MyWithdrawTab.vue";
import RunningTradeTab from "@/components/TradeMaster/TradingMarketTab/RunningTradeTab.vue";
export default {
    components: {
    MyDepositTab,
    MyWithdrawTab,
    ClosedTradeTab,
    RunningTradeTab,
  },
};
</script>

<style>
</style>